import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from 'react';
import { initialPeso, initialPlantas, propsCupo, propsPeso, propsPlantas } from '../../utils/formsInitialsStates';
import { useDoneFetchActions } from '../../hooks/useDoneFetchActions';
import useForm from '../../hooks/useForm';
import { getCuposByPlanta, getPlantas } from '../../services/adminServices';
import Select from 'react-select'
import { dateToInput } from '../../utils/utility';
import { getTinas } from '../../services/tinaServices';
import { v4 as uuidv4 } from 'uuid';

export type PesoSubmitValues = propsPeso & { uuid: string };

interface Props {
  handleSubmit?: (values: PesoSubmitValues) => void;
  data?: propsPeso,
  on?: string
}
export const PesoForm = forwardRef(({ handleSubmit, data, on }: Props, ref) => {
  const doneFetchActions = useDoneFetchActions();
  const { handleInputChange, formValues, resetForm, changeMulti, validateForm } = useForm<propsPeso>(initialPeso);
  const form = useRef<HTMLFormElement>(null);
  const [plantas, setPlantas] = useState([initialPlantas])
  const [tinas, setTinas] = useState([{ id: 0, nombre: '' }])
  const [cupos, setCupos] = useState<Array<{ value: string; label: string; }>>()
  const [movementUuid, setMovementUuid] = useState(() => uuidv4())

  const submitForm = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    handleSubmit && handleSubmit({ ...formValues, uuid: movementUuid })
  }

  useEffect(() => {
    
    doneFetchActions(getPlantas()).then((resp: [propsPlantas]) => {
      setPlantas(resp);
    })
    doneFetchActions(getTinas({})).then(({ rows }) => {
      setTinas(rows.map((r: any) => ({ id: r.id, nombre: r.nombre_tina })))
    })
  }, [doneFetchActions])


  useEffect(() => {
    if (formValues.id_planta) {
      doneFetchActions(getCuposByPlanta({ planta: Number(formValues.id_planta) })).then((resp: [propsCupo]) => {
        setCupos(resp.map(ob => ({ value: String(ob.id), label: String(ob.codigo) })))
      })
    }
  }, [formValues.id_planta, doneFetchActions])

  useImperativeHandle(ref, () => ({
    handleClick: () => {
      form.current?.requestSubmit();
      if (form.current && validateForm(form.current.elements)) {
        return { ...formValues, uuid: movementUuid };
      }
    },
    resetForm: () => {
      setMovementUuid(uuidv4());
      if (on === "add") {
        changeMulti({ id_cupo: undefined, cantidad: '' })
        return;
      }
      resetForm();
    },
  }));
  useEffect(() => {
    if (data) changeMulti(data);
  }, [data, changeMulti])

  useEffect(() => {
    if (on) setMovementUuid(uuidv4());
  }, [on, data?.id])

  return (
    <form className="p-3" ref={form} autoComplete="off" onSubmit={submitForm} noValidate>
      <input type="hidden" name="uuid" value={movementUuid} readOnly />
      <div className="row">
        <div className="col-md-6">
          <div className="form-floating mb-3">
            <select className="form-select" id="id_planta" name="id_planta" value={formValues.id_planta} onChange={handleInputChange} disabled={on !== "add"} required>
              <option value="" disabled>Seleccione una planta</option>
              {plantas.map(p => <option key={`plata_${p.id}`} value={p.id}>{p.nombre}</option>)}
            </select>
            <label htmlFor="id_planta">Planta</label>
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-floating mb-3">
            <Select
              className='form-select'
              placeholder='Seleccione el cupo'
              classNamePrefix='react-select-btsp'
              noOptionsMessage={() => 'Cupos no encontrados'}
              isClearable options={cupos}
              value={cupos?.find(cp => cp.value === String(formValues.id_cupo)) || { value: '' }}
              onChange={(a) => {
                const target = document.getElementById('id_cupo') as HTMLInputElement;
                target.value = a?.value || '';
                handleInputChange({ target })
              }}
            />
            <label htmlFor="id_cupo">Cupo</label>
            <input type='hidden' name='id_cupo' id='id_cupo' value={formValues.id_cupo} required />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <div className="form-floating mb-3">
            <input type="number" className="form-control" id="peso_entrada_lts" name="peso_entrada_lts" value={formValues.peso_entrada_lts} onChange={handleInputChange}
              placeholder="-" data-uppercase="change" data-trim="change" disabled />
            <label htmlFor="peso_entrada_lts">Litros de entrada</label>
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-floating mb-3">
            <input type="number" className="form-control" id="peso_salida_lts" name="peso_salida_lts" value={formValues.peso_salida_lts} onChange={handleInputChange}
              placeholder="-" data-uppercase="change" data-trim="change" disabled />
            <label htmlFor="peso_salida_lts">Litros de salida</label>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <div className="form-floating mb-3">
            <input type="number" className="form-control" id="cantidad" name="cantidad" value={formValues.cantidad} onChange={handleInputChange}
              placeholder="-" data-min='0' data-uppercase="change" data-trim="change" required />
            <label htmlFor="cantidad">Litros</label>
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-floating mb-3">
            <select className="form-select" id="tipo_estado" name="tipo_estado" value={formValues.tipo_estado || (on === "add" && 15) || 0} onChange={handleInputChange} >
              <option value={0} >Seleccione un estado</option>
              <option value={10} >Pendiente de resolver</option>
              <option value={15} >Resuelto</option>
            </select>
            <label htmlFor="cantidad">Estado del comentario</label>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-6">
          <div className="form-floating mb-3">
            <select className="form-select" id="id_tina" name="id_tina" value={formValues.id_tina} onChange={handleInputChange} >
              <option value="">Seleccione una tina</option>
              {tinas.map(p => <option key={`tina_${p.id}`} value={p.id}>{p.nombre}</option>)}
            </select>
            <label htmlFor="id_tina">Deposito</label>
          </div>
        </div>
        <div className="col-md-6">
          <div className="form-floating mb-3">
            <input type='date' className="form-control" id="fecha" name="fecha" value={dateToInput(formValues.fecha)} onChange={handleInputChange} />
            <label htmlFor="fecha">Fecha</label>
          </div>
        </div>
      </div>
      <div className="row">
        <div className="col-md-12">
          <div className="form-floating mb-3">
            <textarea className="form-control" id="comentario" name="comentario" value={formValues.comentario} onChange={handleInputChange}
              placeholder="-" data-trim="submit" />
            <label htmlFor="comentario">Comentario</label>
          </div>
        </div>
      </div>
    </form>
  )
})
